
<label *ngIf="labelInput" [attr.for]="removeSpaces(labelInput)">{{labelInput}}</label> <span *ngIf="mandatory" class="mandatory">*</span>

<p-calendar #calendar dateFormat="dd/mm/yy" 
  [inputId]="removeSpaces(labelInput)"
  [placeholder]="placeholder || 'Inserire '+ labelInput"
  [ngModel]="_value|millisecondsToDate" 
  (ngModelChange)="onSelect($event)"
  [disabled]="disabled || submitPending"
  [style]="{'width':'100%'}" 
  [inputStyle]="{'width':'100%'}" 
  [minDate]="minDate" 
  [maxDate]="maxDate"
  [baseZIndex]="1051"
  appendTo="body"
  [showClear]="true">
